// src/environments/environment.dev.ts
export const environment = {
  production: true,
  tenant_Name: 'staging',
  apiUrl: 'https://qabackend.stupaevents.com/',
  adminUrl: 'https://stageadmin.stupaevents.com/admin/dummy/',
  socket_url: 'wss://stagesocket.stupaevents.com/ws/staging',
  logo: "../../../assets/logo/new_stupa_logo.png",
  logo_dark: "../../../assets/logo/new_stupa_logo.png",
  logo_light: "../../../assets/logo/black_theme_logo.png",
  favicon: "../../../assets/logo/stupafav.png",
  title: "Stupa Web",
  ogDescription: 'Stupa Events - Web',
  is_leaderboard_available: true,
  is_membership_available: true,
  is_overview_available: true,
  is_awards_standing_available: true,
  language: 'en',
  show_table_view: true, // based on this i am showing the table view selected first else we are shoing the standard view
  show_standard_view: true, // based on this i am showing the standard view selected first else we are shoing the table view
  currency: 'CHF',
  show_sign_up: true,
  sport_id: 1,
  is_invoice_history: false,
  default_banner: '',
  show_home_membership_cards: true,
  show_broadcasts: true,
  show_live: true,
  show_player_dashboad: true,
  show_membership_in_player_dashboard: false,
  theme_name: 'default',
  website_url: 'https://stupasports.ai/',
  use_ranking: true,
  use_rating: true,
  show_sub_license: true,
  is_league_leaderboard_available: true,
  is_tournament_leaderboard_available: true,
  common_storage_url: 'https://storage.googleapis.com/stupaprodsguscentral',
  hide_travel_and_accommodation_for_admin_and_ott: false,
  term_conditions_url: 'https://storage.googleapis.com/stupaprodsguscentral/UserProfile/Stupa%20-%20Platform%20Privacy%20Policy_261225_20260219-050817.pdf',
  show_loan_and_transfer: false,
  show_license_table: true,
  analytics: {
    google: { enabled: true, measurementId: 'G-1LZRLKEYRY' },
  },
  hide_options_for_switz: false,
  template: 1,
};

